import React, { SVGAttributes } from 'react';
import { forwardRef } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
interface TickInCircleProps extends React.SVGProps<SVGSVGElement> {
  isSelected?: boolean;
}
const TickInCircle = forwardRef<SVGSVGElement, TickInCircleProps>(({
  isSelected = false,
  ...props
}, ref) => {
  return <svg fill="none" viewBox="0 0 28 28" {...props} ref={ref}>
        {isSelected ? <g clip-path="url(#a)">
            <path fill="#000" stroke="#c5ced6" stroke-width=".1" d="M14 2.675A11.35 11.35 0 0 1 25.325 14l-.008.419a11.327 11.327 0 0 1-19.325 7.589 11.326 11.326 0 0 1 7.59-19.325zm4.83 7.8a.93.93 0 0 0-.652.228l-.001.001-5.785 5.513-2.569-2.45a.924.924 0 1 0-1.27 1.342l3.203 3.06a.9.9 0 0 0 .637.256v-.001a.94.94 0 0 0 .578-.194l.068-.06 6.41-6.124.001-.002a.924.924 0 0 0-.62-1.568Z" />
          </g> : <g stroke="#c5ced6" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.601" clip-path="url(#a)">
            <path d="m18.813 11.375-6.42 6.125-3.206-3.062" />
            <path d="M14 24.5c5.799 0 10.5-4.701 10.5-10.5S19.799 3.5 14 3.5 3.5 8.201 3.5 14 8.201 24.5 14 24.5" />
          </g>}
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h28v28H0z" />
          </clipPath>
        </defs>
      </svg>;
});
export default TickInCircle;